import { MultiSelectOption } from "./components/row";

export interface Localization {
  configurator: {
    locale: string;
    poolType: null | string;
    submitConfiguration: (config: any) => void;
    i18n: {
      panelTitle: string;
      poolTypeLabel: string;
      defineYours: string;
      submitLabel: string;
      poolType: string;
      poolDimensions: string;
      poolColor: string;
      poolLength: string;
      poolWidth: string;
      poolDepth: string;
      coverSystem: string;
      poolCover: string;
      options: string;
      spots: string;
      systemPlage: string;
      systemPit: string;
      stairs: string;
      day: string;
      night: string;
      poolType_5: string;
      poolType_6: string;
      poolType_7: string;
      poolType_8: string;
      none:string;
      floatingStairsLabel:string;
      yes:string;
      no:string;
      optionPlage:string;
    };
  };
}

const remoteData: Localization = (window as any).flexline;
const localization = remoteData.configurator.i18n;

export const poolTypesOptions = [
  { display: "Skimmer", data: "std" },
  { display: "Infinity", data: "infinity" },
  { display: "Overflow", data: "overflow" },
  { display: "Natural", data: "pond" },
]

export const poolColors = [
  {
    displayColor: 0xa1e4ed,
    valueColor: 0xffffff,
    name: "Timeless White",
  },
  {
    displayColor: 0x90cbd4,
    valueColor: 0xdedede,
    name: "Versatile Grey",
  },
  {
    displayColor: 0x81afb5,
    valueColor: 0xaaaaaa,
    name: "Sophisticated Grey",
  },
  {
    displayColor: 0x4b7276,
    valueColor: 0x888888,
    name: "Deep Anthracite",
  },
];

export const poolCoverOptions: MultiSelectOption[] = [
  { display: localization.none, data: "None" },
  { display: "Covrex", data: "Covrex" },
  { display: "Quadro", data: "Quadro" },
];

export const coverTypeOptions: MultiSelectOption[] = [
  { display: localization.optionPlage, data: "Plage" },
  { display: "Cover Pit", data: "Cover Pit" },
];

export const spotOptions: MultiSelectOption[] = [
  { display: "1", data: 1 },
  { display: "2", data: 2 },
  { display: "3", data: 3 },
];

export const yesNoOptions: MultiSelectOption[] = [
  { display: localization.yes, data: true },
  { display: localization.no, data: false },
];

export const stairsOptions: MultiSelectOption[] = [
  { display: "Pure", data: "Pure" },
  { display: "Excellence", data: "Excellence" },
  { display: "Slash", data: "Slash" },
]


